/**
 * aggregate-viewing-time-by-bvod-service-1-week
 *
 * @author    Andy Lowe <andy.lowe@mediatel.co.uk>
 * @copyright 2019 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "../common/core";
import sandboxFactory from "../common/sandbox";

// Modules:
import weeklyPeriodSelectsFactory from "../tv-player-report/weekly-period-selects-open";
import weeklyViewingSummary from "../tv-player-report/aggregate-viewing-time-by-bvod-service";
import datatypeSelectFactory from "../tv-player-report/datatype-select";
import tableFilter from "../common/table-filter";
import moreInfo from "../top-programmes/more-info";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule("display_data_block", datatypeSelectFactory);
core.createModule(
    "period_selects",
    weeklyPeriodSelectsFactory(
        "tv-player-report/get-aggregate-viewing-available-weeks",
        {type: "tvpr_aggregate_bvod"}
    )
);
// Not really happy with adding on to the query string, but it appears to be the easiest way without having to
// duplicate more javascript files.
core.createModule(
    "weekly_summary",
    weeklyViewingSummary(
        "tv-player-report/weekly-aggregate-viewing-time-by-bvod-service?report-type=open",
        {showSkyPcNote: "true"}
    )
);
core.createModule("moreInfo", moreInfo);
core.createModule("table_filter", tableFilter);

core.startAll();